var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./WeighbridgeConsignmentItem.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-816d23ce\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./WeighbridgeConsignmentItem.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/loads/weighbridge/WeighbridgeConsignmentItem.vue
// module id = 844
// module chunks = 0